import { Link } from "react-router-dom";

export function PrivacyPage() {
  return (
    <div className="center">
      <div className="card" style={{ maxWidth: 800, margin: "2rem auto" }}>
        <h1>Privacy Statement</h1>
        <p className="muted">Last updated: 18 May 2026</p>

        <p>
          Anj Industries ("we", "us") operates BT-1851 Cloud ("the
          Service"). This statement explains what personal information
          we collect, how we use it, and your rights under the Australian
          Privacy Act 1988 (Cth).
        </p>

        <h2>What we collect</h2>
        <ul>
          <li>
            <strong>Account information.</strong> Email address, display
            name, and (where you sign in via Google or Microsoft) the
            OAuth subject identifier and profile image. We do not store
            passwords for OAuth sign-ins.
          </li>
          <li>
            <strong>Organisation membership.</strong> The organisation
            you belong to and your role within it.
          </li>
          <li>
            <strong>Device records.</strong> Identifiers and metadata
            for BT-1851 devices you have paired with your organisation,
            including device serial number and firmware version.
          </li>
          <li>
            <strong>Test data.</strong> Battery test results uploaded
            from paired devices: time-series voltage and current samples,
            test parameters, and PDF reports generated on the device.
          </li>
          <li>
            <strong>Operational logs.</strong> Standard web access logs
            (IP address, country code from Cloudflare, user agent,
            request path, response code, timestamp). Used for security
            monitoring and debugging. Logs are retained for 90 days.
          </li>
        </ul>

        <h2>How we use it</h2>
        <ul>
          <li>To provide the Service: authenticate you, present your
              devices and tests, deliver firmware updates to your
              paired devices.</li>
          <li>To respond to support requests.</li>
          <li>To detect and respond to security incidents (e.g.,
              rate-limit abuse, credential-stuffing attempts).</li>
          <li>To comply with legal obligations.</li>
        </ul>

        <p>
          We do not use your data for advertising, profiling, or third-
          party marketing. We do not sell your data.
        </p>

        <h2>Where it is stored</h2>
        <p>
          Account information and device metadata are stored in
          Cloudflare D1 (a managed SQLite service). Test data and PDF
          reports are stored in Cloudflare R2 object storage. Both
          services are operated by Cloudflare, Inc., with primary
          replicas located in the Asia-Pacific region (typically
          Sydney). Operational logs are stored in the same Cloudflare R2
          bucket with a 90-day lifecycle policy.
        </p>

        <h2>Sub-processors</h2>
        <p>We rely on the following sub-processors:</p>
        <ul>
          <li><strong>Cloudflare, Inc.</strong> — hosting, storage, edge
              network, DDoS protection, bot challenges (Turnstile).</li>
          <li><strong>Resend.</strong> — transactional email delivery
              (verification, password reset, org invitations).</li>
          <li><strong>Google LLC</strong> — optional sign-in provider.
              Only invoked if you choose to sign in with Google.</li>
          <li><strong>Microsoft Corporation</strong> — optional sign-in
              provider. Only invoked if you choose to sign in with
              Microsoft.</li>
        </ul>

        <h2>Sharing</h2>
        <p>
          We do not share your personal information with third parties
          except: (a) the sub-processors listed above, strictly to
          provide the Service; (b) when required by law (e.g., a valid
          subpoena or court order); or (c) to protect the rights,
          property, or safety of Anj Industries, our users, or the
          public.
        </p>

        <h2>Your rights</h2>
        <p>
          You have the right to access, correct, export, or delete the
          personal information we hold about you:
        </p>
        <ul>
          <li>Access and correction — manage your profile from the
              Account page within the Service.</li>
          <li>Export — request an export of your data by emailing{" "}
              <a href="mailto:privacy@ausforce.com.au">privacy@ausforce.com.au</a>.</li>
          <li>Deletion — use "Delete account" on the Account page, or
              email us. Account deletion removes your profile and
              authentication records; organisation-owned device records
              and test data remain with the organisation and are not
              automatically deleted on individual user removal.</li>
        </ul>

        <h2>Cookies and session storage</h2>
        <p>
          The Service uses first-party cookies to maintain your signed-
          in session. We do not use third-party analytics or advertising
          cookies. Cloudflare may set technical cookies (e.g., for bot
          detection); see <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener">Cloudflare's
          privacy policy</a> for details.
        </p>

        <h2>Children</h2>
        <p>
          The Service is not directed at children under 16. We do not
          knowingly collect personal information from children.
        </p>

        <h2>Security</h2>
        <p>
          We use TLS for all data in transit, store passwords using
          bcrypt, and rotate refresh tokens on every use. Sensitive
          operations (sign-up, password reset) are rate-limited at the
          edge and gated by Cloudflare Turnstile.
        </p>

        <h2>Changes to this statement</h2>
        <p>
          We may update this statement from time to time. The "Last
          updated" date at the top reflects the current version.
        </p>

        <h2>Contact</h2>
        <p>
          For any privacy question or to exercise your rights, email{" "}
          <a href="mailto:privacy@ausforce.com.au">privacy@ausforce.com.au</a>.
          If you are dissatisfied with our response, you may lodge a
          complaint with the Office of the Australian Information
          Commissioner (<a href="https://www.oaic.gov.au/" target="_blank" rel="noopener">oaic.gov.au</a>).
        </p>

        <p style={{ marginTop: "2rem" }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
